<fgb-banner [pageTitle]="'badge.banner' | translate" />

<fgb-page-header [pageTitle]="'account.page.title'"></fgb-page-header>

<fgb-account-nav></fgb-account-nav>

<!--Scorecard carousel-->
<!-- <fgbcl-scorecard-carousel
  [icon]="'chevron_right'"
  [showAllView]="false"
  [version2Design]="true"
  [phaseThree]="true"
  [showPlaceholder]="true"
></fgbcl-scorecard-carousel> -->

<div class="container">
  <fgbcl-badge-overview-list></fgbcl-badge-overview-list>
</div>
